export type WhatsNewScope = 'user' | 'manager' | 'admin';

export type WhatsNewItem = {
  icon: 'delete_sweep' | 'person_check' | 'auto_awesome_mosaic' | 'search' | 'date_range';
  title: string;
  description: string;
  audiences: WhatsNewScope[];
};

export type WhatsNewRelease = {
  /**
   * Change this id on every release where the modal should re-appear.
   * Stored in localStorage per-user; the modal is shown until dismissed twice.
   */
  id: string;
  title: string;
  items: WhatsNewItem[];
  learnMoreUrl: string;
};

const EVERYONE: WhatsNewScope[] = ['user', 'manager', 'admin'];

export const WHATS_NEW_RELEASE: WhatsNewRelease = {
  /** Bump when content changes so the modal can show again for each release. */
  id: '2026-10-15',
  title: "What's New in EWRS",
  items: [
    {
      icon: 'search',
      title: 'Search by desk number',
      description: 'Find a specific desk using the search bar in your results',
      audiences: EVERYONE,
    },
    {
      icon: 'date_range',
      title: 'Last week team view',
      description: "View your team's booking statuses from last week in My team",
      audiences: ['manager'],
    },
    {
      icon: 'delete_sweep',
      title: 'Cancel multiple bookings',
      description: 'Select the bookings you want to cancel and remove them in one go',
      audiences: EVERYONE,
    },
    {
      icon: 'person_check',
      title: 'Self-serve registration',
      description: 'New team members can now register directly with manager approval',
      audiences: ['manager', 'admin'],
    },
    {
      icon: 'auto_awesome_mosaic',
      title: 'Refreshed admin interface',
      description: 'Admin pages have been redesigned with a modern & consistent interface',
      audiences: ['admin'],
    },
  ],
  learnMoreUrl: '/docs/change-log',
};
